"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/sessions`;
    }
    /**
     * Returns the list of Webinar Sessions hosted by a current authorized user sorted by
   * 'scheduledStartTime' or 'creationTime' (if 'scheduledStartTime' is not set) in the ascending order
   *
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/sessions
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map